import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles,
    Typography,
    List,
    ListItem,
} from '@material-ui/core';

import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import {
    PersonIcon,
    PhoneIcon,
    EmailIcon,
    UserAccessIcon,
} from '../../../common/icons';
import { VimoModal } from '../../../common/components';
import EditContactPerson from './EditContactPerson';

const styles = theme => ({
    listItem: {
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1, 0.5),
    },
    text: {
        flex: '1 1 auto',
    },
    role: {
        color: theme.colors.grey3,
    },
    personIcon: {
        fontSize: theme.sizes.mediumIcon,
        marginRight: theme.spacing(1),
    },
    icon: {
        marginLeft: theme.spacing(0.5),

        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
});

const ContactOverview = ({
    classes, contactData, patientId, readOnly,
}) => {
    const [showModal, setShowModal] = React.useState(false);
    const translate = useSelector(state => getTranslate(state.localize));

    const onClick = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <ListItem button={!readOnly} onClick={readOnly ? null : onClick} className={classes.listItem}>
                <PersonIcon className={classes.personIcon} color="secondary" />
                <div className={classes.text}>
                    <Typography variant="h6">{ contactData.name}</Typography>
                    <Typography className={classes.role}>{ contactData.role}</Typography>
                </div>
                {contactData.phone && (
                    <PhoneIcon color="primary" className={classes.icon} titleAccess={contactData.phone} />
                )}
                {contactData.email && (
                    <EmailIcon color="primary" className={classes.icon} titleAccess={contactData.email} />
                )}
                {contactData.canLogin && (
                    <UserAccessIcon color="primary" className={classes.icon} titleAccess={translate('studentEdit.canLogin')} />
                )}
            </ListItem>

            <VimoModal
                open={showModal}
                onClose={closeModal}
                heading={contactData.name}
            >
                <EditContactPerson contactData={contactData} onClose={closeModal} patientId={patientId} />
            </VimoModal>
        </>
    );
};

ContactOverview.propTypes = {
    classes: PropTypes.object.isRequired,
    contactData: PropTypes.object.isRequired,
    patientId: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
};

ContactOverview.defaultProps = {
    readOnly: false,
};

const ContactOverviewWithStyles = withStyles(styles)(ContactOverview);

const ContactPersonList = ({ persons, patientId, readOnly }) => {
    if (!persons) {
        return null;
    }

    return (
        <List>
            {persons.map(person => (
                <ContactOverviewWithStyles
                    contactData={person}
                    patientId={patientId}
                    key={person.id}
                    readOnly={readOnly}
                />
            ))}
        </List>
    );
};

ContactPersonList.propTypes = {
    persons: PropTypes.array.isRequired,
    patientId: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
};

ContactPersonList.defaultProps = {
    readOnly: false,
};

export default ContactPersonList;
